import type { Dict } from '@aviata/platform-types';
import { dictEntity } from 'shared';

import { parseRouteEndpoints } from './parse-route-endpoints';

function pickLocalizedName(
  city: Dict.Cities.City | undefined,
  locale: string,
): string | undefined {
  if (!city) return undefined;
  if (locale === 'kk') return city.name_kk || city.name;
  if (locale === 'en') return city.name_en || city.name;
  return city.name_ru || city.name;
}

function findCityByCode(
  code: string,
  dict: Dict.Entity,
): Dict.Cities.City | undefined {
  if (dict.cities?.[code]) return dict.cities[code];
  return Object.values(dict.airports ?? {}).find(ap => ap.city?.iata === code)
    ?.city;
}

function localizedLocationName(
  code: string,
  dict: Dict.Entity | undefined,
  locale: string,
): string {
  if (!dict) return code;

  const fromAirport = dictEntity.lib.getCityByAirport(code, dict);
  const nameFromAirport = pickLocalizedName(fromAirport, locale);
  if (nameFromAirport) return nameFromAirport;

  const fromCity = findCityByCode(code, dict);
  const nameFromCity = pickLocalizedName(fromCity, locale);
  if (nameFromCity) return nameFromCity;

  const ap = dictEntity.lib.getAirport(code, dict);
  return ap?.name ?? code;
}

export function routeTitleFromEndpoints(
  dep: string,
  arr: string,
  dict: Dict.Entity | undefined,
  locale: string,
): string {
  const depName = localizedLocationName(dep, dict, locale);
  const arrName = localizedLocationName(arr, dict, locale);
  return `${depName} — ${arrName}`;
}

export function routeTitleFromRouteString(
  route: string | undefined,
  dict: Dict.Entity | undefined,
  locale: string,
): string | null {
  if (!route) return null;
  const { dep, arr } = parseRouteEndpoints(route);
  if (!dep || !arr) return null;
  return routeTitleFromEndpoints(dep, arr, dict, locale);
}
